import React from "react";
import styles from "./styles.module.scss";
import useWindowWidth from "hooks/useWindowWidth";

const Map = () => {
  const width = useWindowWidth();
  return (
    <div className="container">
      <div className={styles.text}>
        200 Continental Drive, Suite 401, Newark, Delaware, 19713
      </div>
      <div className={styles.map}>
        {width > 767 ? (
          <img
            src="/svgs/who-we-are/map_desc.svg"
            width="1200"
            height="218"
            alt="map_desc"
          />
        ) : (
          <img
            width="288"
            height="306"
            src="/svgs/who-we-are/map_mobile.svg"
            alt="map_mobile"
          />
        )}
      </div>
    </div>
  );
};

export default Map;
